import React, { useState } from 'react'
import { icon } from '../Icons'
import './styles.scss'

export default function PessoaEnvolvida(props) {

    const [show, setShow] = useState(true)

    const secaoPessoaEnvolvida = () => {
        return (
            <fieldset>
                <div className="form-group col-sm-10"> 
                    <label>Nome:</label>
                    <input 
                        id={ "idFormDenunciaNomeEnvolvido_" + props.indice }
                        key={ "keyFormDenunciaNomeEnvolvido_" + props.indice }
                        name="nome"
                        type="text" 
                        className="form-control" 
                        placeholder="Digite o nome (opcional)" 
                        value={ props.pessoaEnvolvida.nome }
                        onChange={ 
                            event => props.atualizarPessoaEnvolvida(
                                'nome',
                                event.target.value,
                                props.indice
                            )
                        }
                    />
                </div>
                <div className="form-group col-sm-10"> 
                    <label>Cargo:</label>
                    <input 
                        id={"idFormDenunciaCargoEnvolvido_" + props.indice}
                        name="cargo"
                        type="text" 
                        className="form-control" 
                        placeholder="Digite o cargo (opcional)" 
                        value={ props.pessoaEnvolvida.cargo }
                        onChange={ 
                            event => props.atualizarPessoaEnvolvida(
                                'cargo',
                                event.target.value,
                                props.indice
                            )
                        }
                    />
                </div>
                <div className="form-group col-sm-10"> 
                    <label>Área/Departamento:</label>
                    <input 
                        key={"idFormDenunciaAreaDepartamento_" + props.indice}
                        name="areaDepartamento"
                        type="text" 
                        className="form-control" 
                        placeholder="Digite a Área/Departamento (opcional)" 
                        value={ props.pessoaEnvolvida.areaDepartamento }
                        onChange={ 
                            event => props.atualizarPessoaEnvolvida(
                                'areaDepartamento',
                                event.target.value,
                                props.indice
                            )
                        }
                    />
                </div>
            </fieldset>
        )
    }

    const renderTrash = () => {
        return (
            <button 
                id={"idFormDenunciaEnvolvidoTrash_" + props.indice}
                key={"keyFormDenunciaEnvolvidoTrash_" + props.indice}
                className="btn btn-default ml-4"
                onClick={ () => props.removerPessoaEnvolvida(props.indice) }
                type="button"
            >
                <icon.FaRegTrashAlt className="text-danger" />
            </button>
        )
    }

    const botaoChaveado = () => {
        return(
            <fieldset 
                key={ "keyEnvolvido_" + (props.indice + 1) } 
                className="d-block clicavel-envolvido" 
                onClick={ () => setShow(!show) }
            >
                <strong><h4><small>
                    { "Envolvido_" + (props.indice + 1) }:
                    { 
                        show? 
                            <icon.BsPlusCircle className="text-primary ml-1" /> 
                        :
                            <icon.FiMinusCircle className="text-danger ml-1" /> 
                    }
                    { renderTrash() }
                </small></h4></strong>
            </fieldset>
        )
    }

    return (
        <li className="list-group-item">
            { botaoChaveado() }
            <div className={ (show? 'd-none' : 'd-block') }>
                { secaoPessoaEnvolvida() }
            </div>
        </li>
    )
}